import './Theme.Other.VerticalDivider.scss';
export default 'ThemeOtherVerticalDivider';
